import { useMemo } from "react";
import Button from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import type { ProductDetails } from "@/lib/centra/formatters";
import type { Sizes } from "@/lib/centra/hooks/useSizes";
import { EasySizeButton } from "./EasySizeButton";
import { createEasySizeConfig } from "./easysize";
import styles from "./index.module.css";

export const SizeGuideButton = ({
  activeVariant,
  productId,
  sizes,
  addToCartId,
}: {
  activeVariant?: ProductDetails;
  productId: string;
  sizes: Sizes;
  addToCartId: string;
}) => {
  const t = useTranslations();
  const config = useMemo(() => {
    return createEasySizeConfig({ activeVariant, productId, addToCartId });
  }, [activeVariant, productId, addToCartId]);

  if (!activeVariant || !config)
    return (
      <Button mode="link" className={styles.sizeguide}>
        <span className={styles.sizeLabel}>{t("sizeguide.title")}</span>
      </Button>
    );

  return <EasySizeButton sizes={sizes} config={config} />;
};
